import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-6 bg-charcoal text-cream relative overflow-hidden" data-id="element-138">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-terracotta/10 rounded-full blur-[100px] pointer-events-none" data-id="element-139"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" data-id="element-142">
            El Sistema 3R Express™
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-143">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 my-10" data-id="element-144">
            {['Reducir', 'Regular', 'Reactivar'].map((word, i) => <div key={word} className="flex items-center gap-4" data-id="element-145">
                <span className="text-xl md:text-2xl font-playfair italic text-terracotta tracking-wide" data-id="element-146">
                  {word}
                </span>
                {i < 2 && <span className="hidden md:block w-2 h-2 rounded-full bg-sage/50" data-id="element-147"></span>}
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-148">
          <p className="text-lg md:text-xl leading-relaxed text-cream/80 max-w-3xl mx-auto font-light" data-id="element-149">
            No es una dieta, es un interruptor químico. En lugar de contar
            calorías, inundamos tu sistema con nutrientes específicos que
            fuerzan al cuerpo a soltar el glucógeno y el agua retenida en tiempo
            récord. Al estabilizar la glucosa y bajar el cortisol, el abdomen se
            desinflama de forma natural en solo 48 horas.
          </p>
        </FadeIn>
      </div>
    </section>;
}